import axios from 'axios';

export const fetchProtectedImg = async (url: string) => {
  return axios({
    url,
    method: 'GET',
    responseType: 'blob',
  }).then((response) => {
    return window.URL.createObjectURL(new Blob([response.data]));
  });
};
